<p-dialog [(visible)]="showDialog" [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
  [closable]="false" [style]="{width: '75vw'}">
  <ng-template pTemplate="header">
    <div [style]="{width: '100%'}">
      <app-cloud-status [status]="cloudStatus"></app-cloud-status>
    </div>
  </ng-template>
  <div>
    <span><b>{{ 'cloud_status_info_text' | i18next }}</b></span>
  </div>
  <ng-template pTemplate="footer">
    <button class="btn btn-outline-primary" (click)="showDialog=false">{{ 'button_text_understood' | i18next }}</button>
  </ng-template>
</p-dialog>